import { createFeatureSelector, createSelector } from '@ngrx/store';

import { AuthState, featureKey } from './auth.reducer';

const selectFeature = createFeatureSelector<AuthState>(featureKey);

export const selectIsAuthenticated = createSelector(selectFeature, (state) => state.isAuthenticated);
export const selectLoading = createSelector(selectFeature, (state) => state.loading);
export const selectError = createSelector(selectFeature, (state) => state.error);
export const selectAccount = createSelector(selectFeature, (state) => state.account);
export const selectAccountInitiallyRequested = createSelector(
    selectFeature,
    (state) => state.accountInitiallyRequested
);
export const selectUrlAfterLogin = createSelector(selectFeature, (state) => state.urlAfterLogin);
